<template>
    <div :id="id" class="modal modal--xs">
        <div class="modal-form">
            <div class="modal-form__header">
                <div class="modal-form__title">
                    <slot name="title"></slot>
                </div>
            </div>
            <slot :close="close" :confirm="confirm" :decline="decline" :is-opened="isOpened"></slot>
        </div>
    </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue';

export default {
    name: "PopupBlock",
    props: {
        opened: {
            type: Boolean,
            default: false,
        },
        autoopen: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "",
        },
        type: {
            type: String,
            default: 'left',
        },
    },
    emits: ['open', 'close', 'decline', 'confirm'],
    setup(props, { emit }) {

        let fancybox, promiseResolve, action = '';
        const isOpened = ref(false);
        const id = ref(Math.random().toString(36).substring(7));

        const onOpen = () => {
            emit("open");
            isOpened.value = true;
        }

        const onClose = () => {
            promiseResolve(action);
            emit(action);
            emit("close");
            isOpened.value = false;
        }

        const open = () => {
            action = "decline";
            return new Promise((resolve) => {
                let options = {
                    Toolbar: false,
                    dragToClose: false,
                    Thumbs: false,
                    closeButton: "outside",
                    autoFocus: false,
                    mainClass: "fancybox-modal",
                    showClass: "fancybox-zoomIn",
                    hideClass: "fancybox-zoomOut",
                    trapFocus: false,
                    click: (fancybox) => {
                        fancybox.close()
                    },
                    done() {
                        onOpen();
                    },
                    destroy: () => {
                        onClose();
                    },
                }
                // if (props.type == 'some_type') {
                //     options = Object.assign(options, {
                //         mainClass: 'fancybox--left fancybox-fadeInLeft',
                //         hideClass: 'fancybox-throwOutLeft',
                //     });
                // }

                fancybox = new window.fancyboxConstructor([{ src: `#${id.value}`, }], options);

                promiseResolve = resolve;
            });
        }

        const close = () => {
            fancybox ? fancybox.close() : null;
        }

        const confirm = () => {
            action = 'confirm';
            close();
        }

        const decline = () => {
            action = 'decline';
            close();
        }

        watch(() => props.opened, () => {
            if (props.opened) {
                open();
            }
            else {
                close();
            }
        });

        onMounted(() => {
            if (props.autoopen) {
                let testReadyState = setInterval(() => {
                    if (window.fancyboxConstructor && (document.readyState == 'complete' || document.readyState == 'interactive')) {
                        open();
                        clearInterval(testReadyState);
                    }
                }, 500);
            }
        });
        return {
            id,
            close,
            open,
            isOpened,
            confirm,
            decline
        };
    },
};
</script>
